const galleryItems = [
  {
    before: 'https://public.readdy.ai/ai/img_res/7919c94935fdef26b81d9d4af2ca8fb9.jpg',
    after: 'https://readdy.ai/api/search-image?query=beautifully%20manicured%20residential%20lawn%20with%20perfectly%20cut%20grass%2C%20neat%20edges%2C%20fresh%20mulch%20beds%2C%20professional%20landscaping%20results%20in%20Maryland%20suburb%2C%20pristine%20green%20lawn&width=600&height=400&seq=after-001&orientation=landscape',
  },
  {
    before: 'https://readdy.ai/api/search-image?query=old%20faded%20mulch%20beds%20with%20weeds%20growing%20through%2C%20bare%20spots%2C%20unmaintained%20flower%20beds%20around%20house%20foundation%20before%20landscaping%20service%20in%20Maryland&width=600&height=400&seq=before-002&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=fresh%20dark%20brown%20mulch%20installation%20around%20house%20foundation%2C%20clean%20edges%2C%20weed-free%20beds%2C%20vibrant%20plants%2C%20professional%20mulching%20results%20in%20Maryland%20residential%20property&width=600&height=400&seq=after-002&orientation=landscape',
  },
  {
    before: 'https://readdy.ai/api/search-image?query=cracked%20damaged%20concrete%20driveway%20with%20weeds%2C%20stains%2C%20deteriorating%20surface%20before%20repair%20in%20Maryland%20residential%20property%2C%20needs%20professional%20concrete%20work&width=600&height=400&seq=before-003&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=brand%20new%20smooth%20concrete%20driveway%20installation%2C%20clean%20finish%2C%20perfect%20surface%2C%20professional%20concrete%20work%20completed%20in%20Maryland%20residential%20property%2C%20beautiful%20curb%20appeal&width=600&height=400&seq=after-003&orientation=landscape',
  },
  {
    before: 'https://readdy.ai/api/search-image?query=overgrown%20bushes%20and%20shrubs%20blocking%20windows%2C%20untrimmed%20hedges%2C%20wild%20growth%20before%20professional%20trimming%20service%20in%20Maryland%20residential%20yard&width=600&height=400&seq=before-004&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=perfectly%20trimmed%20bushes%20and%20shrubs%20with%20clean%20shapes%2C%20professional%20hedge%20trimming%2C%20neat%20landscape%20design%20in%20Maryland%20residential%20property%2C%20beautiful%20maintained%20greenery&width=600&height=400&seq=after-004&orientation=landscape',
  },
  {
    before: 'https://readdy.ai/api/search-image?query=messy%20yard%20covered%20with%20fallen%20leaves%20and%20debris%2C%20autumn%20cleanup%20needed%2C%20unmaintained%20property%20before%20fall%20cleanup%20service%20in%20Maryland&width=600&height=400&seq=before-005&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=clean%20pristine%20yard%20after%20fall%20cleanup%20service%2C%20all%20leaves%20removed%2C%20neat%20lawn%2C%20professional%20seasonal%20cleanup%20results%20in%20Maryland%20residential%20property&width=600&height=400&seq=after-005&orientation=landscape',
  },
  {
    before: 'https://readdy.ai/api/search-image?query=plain%20dirt%20backyard%20area%20with%20no%20landscaping%2C%20bare%20ground%2C%20needs%20hardscaping%20installation%20before%20transformation%20in%20Maryland%20residential%20property&width=600&height=400&seq=before-006&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=beautiful%20stone%20patio%20hardscape%20installation%20with%20retaining%20wall%2C%20outdoor%20living%20space%2C%20professional%20hardscaping%20completed%20in%20Maryland%20residential%20backyard&width=600&height=400&seq=after-006&orientation=landscape',
  }
];

export function Gallery() {
  return (
    <section id="gallery" className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Before &amp; After Results
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See the transformation we bring to properties throughout Owings Mills, Maryland
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {galleryItems.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="grid grid-cols-2 gap-0">
                <div className="relative h-64">
                  <img 
                    src={item.before}
                    alt="Before landscaping"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 bg-gray-800/80 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold">
                    BEFORE
                  </div>
                </div>
                <div className="relative h-64 border-l-2 border-gray-200">
                  <img 
                    src={item.after}
                    alt="After landscaping"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4 bg-[#4A7C2C]/90 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold">
                    AFTER
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                const navHeight = 80;
                const elementPosition = contactSection.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - navHeight;
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }}
            className="inline-flex items-center gap-2 bg-[#4A7C2C] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#2D5016] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Get Your Free Quote
          </button>
        </div>
      </div>
    </section>
  );
}
